import { useNavigate as useNavigateUmi } from '@umijs/max';
import { useSessionStorageState } from 'ahooks';

// 这里做一层中转 来保存 面包屑
export const useNavigate = () => {
  const navigate = useNavigateUmi();
  const [ObasBreadcrumbData, setObasBreadcrumbData] = useSessionStorageState(
    'obas-breadcrumb-data',
    {
      defaultValue: {},
    },
  );

  const proxuNavigate = (...params) => {
    // 暂存下 信息
    setObasBreadcrumbData({
      ...ObasBreadcrumbData,
      [window.location.pathname]: {
        search: window.location.search,
        state: { ...window?.location?.state },
      },
    });

    navigate(...params);
  };

  return proxuNavigate;
};
